module.exports = __webpack_public_path__ + "img/IMG_5911.cf005a51.jpg";